module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAyElEQVQ4jdXTsUoDQRDG8Z9ykOawSSMI4QxY2icgBKvkAex9gbyDrQ9hoUWsUwbS5CmutjaVYCFCiIWLKGHvuGMD8YOBWWbmz+zM7tF2aoCJNPrIMMBdIuDbcSLQjw4fmFXElnj+dc7RxRjDWFFVhyUWKIKd4AXXeGrTIZzafQF93OO2aYcxXWAdCzYFvuMRV7GEuiuXOA/+J15xiXlbYA8Pwe/4nmlRVVAHzDGqyfmj//1TblRssw3wLFgjHf4M97KUGVaJeJsvkBIXCXyc1y4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PPT.png
// module id = 1106
// module chunks = 0